module.exports = __webpack_public_path__ + "static/media/logo_blue.bc092c91.png";